<template>
  <div>
    <div class="space-y-12 sm:space-y-16">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900">Créer un Challenge</h2>
        <p class="mt-1 max-w-2xl text-sm leading-6 text-gray-600">
          Entrez les informations concernant le nouveau challenge
        </p>
        <hr />
        <FormField
          id="title"
          label="Titre"
          name="title"
          required
          placeholder="Titre du challenge"
          v-model="challenge.title"
        />
        <FormField
          id="startDate"
          label="Date de début"
          name="startDate"
          type="date"
          required
          v-model="challenge.startDate"
        />
        <FormField id="endDate" label="Date de fin" name="endDate" type="date" required v-model="challenge.endDate" />
        <FormField
          id="pointsPerEuro"
          label="Points par Euro"
          name="pointsPerEuro"
          type="number"
          placeholder="Définissez le ratio points/euro"
          v-model="challenge.pointsPerEuro"
        />
      </div>
    </div>
    <ChallengeNewFormSalesTarget @update:salesTargets="addSalesTarget" @remove:salesTargets="removeSalesTarget" />
    <div class="mt-6 flex items-center justify-end gap-x-6">
      <GenericButton @click="createChallenge">Créer</GenericButton>
    </div>
  </div>
</template>
<script>
import ChallengeNewFormSalesTarget from "@/components/challenge/ChallengeNewFormSalesTarget.vue";
import { GenericButton, FormField } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    GenericButton,
    FormField,
    ChallengeNewFormSalesTarget,
  },
  emits: ["success"],
  data() {
    return {
      challenge: this.newChallenge(),
    };
  },
  computed: {
    isDiscountTypeOffered() {
      return this.selectedDiscountType === "offered";
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("challenges", ["create"]),
    newChallenge() {
      return {
        title: "",
        startDate: null,
        endDate: null,
        salesTargets: [],
        pointsPerEuro: null,
      };
    },
    async createChallenge() {
      const { success } = await this.create(this.challenge);
      if (!success) return;

      await this.notify({
        category: "simple",
        type: "success",
        title: "Challenge créé",
        text: "Vous pouvez maintenant ajouter des stores au challenge.",
      });
      this.$emit("success");
      this.challenge = this.newChallenge();
    },
    addSalesTarget(newValue) {
      this.challenge.salesTargets.push(newValue);
    },
    removeSalesTarget(newValue) {
      let salesTarget = this.challenge.salesTargets.find(
        (group) => group.target === newValue.target && group.reward === newValue.reward,
      );

      if (salesTarget) {
        let index = this.challenge.salesTargets.indexOf(salesTarget);

        if (index !== -1) {
          this.challenge.salesTargets.splice(index, 1);
        }
      }
    },
  },
};
</script>
